export default "__VITE_ASSET__DjvbV12r__"